export default {
  CUPOM_FETCHED: 'CUPOM_FETCHED',
  CUPOM_LOAD: 'CUPOM_LOAD',
  CUPOM_TEMPLATES_FETCHED: 'CUPOM_TEMPLATES_FETCHED',
  CUPOM_TEMPLATES_LOAD: 'CUPOM_TEMPLATES_LOAD',
  CUPOM_DETAIL: 'CUPOM_DETAIL',
  CUPOM_BUTTON_LOAD: 'CUPOM_BUTTON_LOAD',
};
